export default __webpack_public_path__ + "static/media/Melisa Bakić.d2fb8ef3.jpg";